import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Container, Section, Stack } from '@fiverr-private/layout_components';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { getMiraEntryPointsVariant } from '@fiverr-private/listing_experiments';
import { MiraNoResultsCard } from '@fiverr-private/mira_entry_points';
import type { ClientInitialProps } from '@fiverr-private/listing_types';
import { AppI18n } from '../../../i18n';
import { GenerateBrief } from './components/GenerateBrief';
import { OrDivider } from './components/OrDivider';

const DM_PREFIX = 'empty_results.empty_search_results.dynamic_matching';
const MIRA_NO_RESULTS_SOURCE = 'mp_search_no_results';

interface EmptySearchResultsProps {
    currency: ClientInitialProps['currency'];
}

export const EmptySearchResults = ({ currency }: EmptySearchResultsProps) => {
    const { abTests } = getContext();
    // Mira entry points experiment: groups 2-4 replace the header and the brief card with MiraNoResultsCard.
    const miraNoResultsVariant = getMiraEntryPointsVariant(abTests);

    return (
        <Section>
            <Stack paddingY="8" alignItems="center" direction="column" gap="10">
                <Stack alignItems="center" direction="column" gap="10">
                    <Stack alignItems="center" direction="column" gap="6">
                        <Stack alignItems="center" direction="column" gap="2">
                            <Heading width={{ default: '100%', sm: '326px' }} as="h5" textAlign="center">
                                <AppI18n k="empty_results.empty_search_results.title" />
                            </Heading>
                            <Text width={{ default: '100%', sm: '380px' }} color="bodySecondary" textAlign="center">
                                <AppI18n k="empty_results.empty_search_results.sub_title" />
                            </Text>
                        </Stack>
                    </Stack>
                </Stack>
                <OrDivider />
                {miraNoResultsVariant ? (
                    <Container width="100%" maxWidth="685px">
                        <MiraNoResultsCard
                            variant={miraNoResultsVariant}
                            source={MIRA_NO_RESULTS_SOURCE}
                            cohort="experiment"
                        />
                    </Container>
                ) : (
                    <>
                        <Typography fontSize="b_md" color="grey_1200">
                            <AppI18n k={`${DM_PREFIX}.mira_header`} />
                        </Typography>
                        <GenerateBrief currency={currency} />
                    </>
                )}
            </Stack>
        </Section>
    );
};
